import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const AstrostarScaleSmall = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path
                    d="M3.00016 14.6667V11.3333M3.00016 4.66668V1.33334M1.3335 3.00001H4.66683M1.3335 13H4.66683M8.66683 2.00001L7.51071 5.00592C7.3227 5.49474 7.2287 5.73915 7.08252 5.94473C6.95296 6.12694 6.79376 6.28614 6.61155 6.4157C6.40597 6.56188 6.16156 6.65588 5.67274 6.84389L2.66683 8.00001L5.67274 9.15613C6.16156 9.34414 6.40597 9.43814 6.61155 9.58432C6.79376 9.71388 6.95296 9.87308 7.08252 10.0553C7.2287 10.2609 7.3227 10.5053 7.51071 10.9941L8.66683 14L9.82295 10.9941C10.011 10.5053 10.105 10.2609 10.2511 10.0553C10.3807 9.87308 10.5399 9.71388 10.7221 9.58432C10.9277 9.43814 11.1721 9.34414 11.6609 9.15613L14.6668 8.00001L11.6609 6.84389C11.1721 6.65588 10.9277 6.56188 10.7221 6.4157C10.5399 6.28614 10.3807 6.12694 10.2511 5.94473C10.105 5.73915 10.011 5.49474 9.82295 5.00592L8.66683 2.00001Z"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeWidth={1.33333}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    'Astrostar'
);
export default AstrostarScaleSmall;
